











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Base extends Vue {
    @Prop({ required: false, default: '#ED4305' })
    protected borderColor!: string;
}
